import { ChangeDetectionStrategy, Component, effect, inject, Renderer2, signal } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import { FeedbackSuccessComponent } from './components/feedback-success/feedback-success.component';
import { FeedbackFormComponent } from './components/feedback-form/feedback-form.component';
import { FeedbackModalParams, FeedbackRequest } from './shared/models/request/feedback-request.model';
import { FeedbackService } from './services/feedback-service.service';
import { AlertService } from '@services/adaptors/alert.service';

@Component({
  selector: 'app-modal-feedback',
  standalone: true,
  imports: [FeedbackFormComponent, FeedbackSuccessComponent],
  templateUrl: './modal-feedback.component.html',
  styleUrls: ['./modal-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalFeedbackComponent {
  private readonly renderer = inject(Renderer2);
  private readonly feedbackService = inject(FeedbackService);
  private readonly alertService = inject(AlertService);
  readonly dialogRef = inject(MatDialogRef<ModalFeedbackComponent, FeedbackRequest>);
  readonly params = inject<FeedbackModalParams>(MAT_DIALOG_DATA);

  readonly isSubmitted = signal(false);

  private submittedValue: FeedbackRequest | null = null;

  constructor() {
    effect(() => {
      const dialogContainer = document.getElementById(this.dialogRef.id);
      if (dialogContainer) {
        this.renderer.setStyle(dialogContainer, 'padding', '0px');
      }
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  handleFormSubmit(submittedValue: FeedbackRequest): void {
    this.feedbackService.createFeedback(submittedValue).subscribe({
      next: () => {
        this.submittedValue = submittedValue;
        this.isSubmitted.set(true);
      },
      error: () => {
        this.alertService.showDefaultErrorMessage();
      }
    });
  }

  handleSuccessConfirm(): void {
    if (this.submittedValue) {
      this.dialogRef.close(this.submittedValue);
      return;
    }
    this.dialogRef.close();
  }

}
